enum AttachmentTypeEnum {
    png = 1,
    jpg,
    bmp,
    pdf,
    acad,
    solid,
    csv,
    doc,
    docx,
    xls,
    xlsx,
    zip,
    svg,
}

export default AttachmentTypeEnum;
